import {Middleware, isRejected} from '@reduxjs/toolkit';
import {Bounce, toast} from 'react-toastify';

export const toastErrorMiddleware: Middleware = () => (next) => (action) => {
    if (isRejected(action)) {
        console.error(action);

        const message =
            'error' in action &&
            typeof action.error === 'object' &&
            'data' in action.error &&
            typeof action.error.data === 'object' &&
            action.error.data != null &&
            'message' in action.error.data &&
            typeof action.error.data.message === 'string'
                ? action.error.data.message
                : 'Oeps! Er is iets mis gegaan.';

        toast.error(message, {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
            transition: Bounce,
        });
    }

    return next(action);
};
